import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  // Tracks the number of ongoing requests
  public totalRequests = 0;

  private readonly isLoading = signal(false);
  private readonly isDisabled = signal(false);

  // Expose as readonly signals
  readonly isLoading$ = this.isLoading.asReadonly();
  readonly isDisabled$ = this.isDisabled.asReadonly();

  constructor() {}

  /**
   * Set the loading state
   */
  setLoading(isLoading: boolean = true): void {
    this.isLoading.set(isLoading);
  }

  /**
   * Set the disabled state
   */
  setDisabled(isDisabled: boolean = true): void {
    this.isDisabled.set(isDisabled);
  }
}
